import apiCCure, { CCureResponse } from "@/services/api.ccure.service";
import { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { cloneDeep } from "lodash";
import {
    LockdownConfigurationByDesignation,
    CCureClearanceState,
    LockdownState,
    UpdatedLockdownClearanceByName,
    StaleConfigurationData,
    UpdateLockdownDetailsPayload
} from "./types";
import Vue from "vue";

export const actions: ActionTree<LockdownState, RootState> = {
    async fetchLockdownConfiguration({ commit, dispatch }, groupID) {
        let response: AxiosResponse<CCureResponse> = await apiCCure.getLockdownConfiguration(groupID);
        if (response && response.data && response.status === undefined) {
            response = response.data as unknown as AxiosResponse<CCureResponse>;
        }

        const ccureDataRequestStatusSuccessful: number = 200;

        if (response && response.status === ccureDataRequestStatusSuccessful && response.data) {
            if (response.data.configuration) {
                if (response.data.configuration.cCureClearanceStates && response.data.configuration.cCureClearanceStates.length > 0) {
                    commit("setLockdownConfiguration", response.data.configuration);
                    await dispatch("processLockdownConfiguration");
                } else {
                    commit("setLockdownConfigurations", []);
                }
            }
            else {
                commit("setLockdownConfigurations", []);
            }
        }
        else {
            throw Error();
        }
    },
    async processLockdownConfiguration({ state, commit }) {
        let distinctNames = [];
        let cCureClearanceStatesMap = {};

        let configurationsByName: LockdownConfigurationByDesignation[] = [];

        for (let i = 0; i < state.lockdownConfiguration.cCureClearanceStates.length; ++i) {
            const name = state.lockdownConfiguration.cCureClearanceStates[i].name;

            if (!distinctNames.includes(name)) {
                distinctNames.push(state.lockdownConfiguration.cCureClearanceStates[i].name);
            }

            if (!cCureClearanceStatesMap[name]) {
                cCureClearanceStatesMap[name] = [state.lockdownConfiguration.cCureClearanceStates[i]];
            } else {
                cCureClearanceStatesMap[name].push(state.lockdownConfiguration.cCureClearanceStates[i]);
            }
        }

        Object.keys(cCureClearanceStatesMap).forEach((name: string) => {
            let cCureClearanceStatesEnabledByDefault = cCureClearanceStatesMap[name].filter((state: CCureClearanceState) => state.enabledByDefault);

            cCureClearanceStatesEnabledByDefault.sort((a: CCureClearanceState, b: CCureClearanceState) => {
                return (a.xfEventClearanceLevel > b.xfEventClearanceLevel) ? -1 : (b.xfEventClearanceLevel > a.xfEventClearanceLevel) ? 1 : 0
            });

            const clearanceLevel = cCureClearanceStatesEnabledByDefault ? cCureClearanceStatesEnabledByDefault[0].xfEventClearanceLevel : null;

            let lockdownConfiguration: LockdownConfigurationByDesignation = {
                serverTitle: cCureClearanceStatesMap[name][0].serverTitle,
                groupId: state.lockdownConfiguration.groupId,
                isDesignated: cCureClearanceStatesMap[name][0].designated,
                availableClearanceLevels: state.lockdownConfiguration.availableClearanceLevels,
                clearanceFilterLevel: clearanceLevel,
                cCureClearanceStates: null,
                name: name,
                selected: false
            }

            configurationsByName.push(lockdownConfiguration);
        });

        commit("setLockdownConfigurations", configurationsByName);
    },
    async updateClearanceFilterLevel({ state, commit, dispatch }, updatedLockdownDetailsByName: UpdatedLockdownClearanceByName[])
    : Promise<boolean> {
        const configurationsCopy = cloneDeep(state.lockdownConfigurations);

        const lockdownConfigurationPayload: UpdateLockdownDetailsPayload = {
            lockdownConfiguration: state.lockdownConfiguration,
            updatedLockdownClearanceLevels: updatedLockdownDetailsByName,
            checkStaleData: true
        };

        commit("setLockdownConfigurationPayload", cloneDeep(lockdownConfigurationPayload));

        const result =  await apiCCure.setLockdownConfiguration(lockdownConfigurationPayload);

        const dataIsStale = !result.data.successful && result.data.configuration;

        if (dataIsStale)
        {
            commit("setLockdownConfiguration", result.data.configuration);
            await dispatch("processLockdownConfiguration");
            dispatch("processStaleData", configurationsCopy);
            return false;
        }

        if (!result.data.successful)
        {
            Vue.notify({
				type: "error",
				title: "Error",
				text: "Unable to update the clearance filter levels"
			});
            return;
        }

        commit("setLockdownConfiguration", result.data.configuration);
        await dispatch("processLockdownConfiguration");

        return true;
    },
    processStaleData({ state, commit }, oldConfigurations: LockdownConfigurationByDesignation[]) {
        let newLockdownConfigurationsCFLMap = {};
        let staleData: StaleConfigurationData[] = [];

        state.lockdownConfigurations.forEach((config: LockdownConfigurationByDesignation) => {
            newLockdownConfigurationsCFLMap[config.name] = config.clearanceFilterLevel
        });

        oldConfigurations.forEach((oldConfig: LockdownConfigurationByDesignation) => {
            if (newLockdownConfigurationsCFLMap[oldConfig.name] != oldConfig.clearanceFilterLevel) {
                staleData.push({
                    lockdownConfiguration: oldConfig,
                    newClearanceLevel: newLockdownConfigurationsCFLMap[oldConfig.name]
                });
            }
        });

        commit("setStaleData", staleData);

        if (staleData.length > 0) {
            commit("setStaleDataModalVisible", true);
        }
    }
}